import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {Definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/blend-by-laplacian-pyramid/definition"
import {ImageOpBlendByLaplacianPyramidHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/blend-by-laplacian-pyramid/hal"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {generateGraph} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/blend-by-laplacian-pyramid/imgproc"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

@registerNode
export class ImageOpNodeBlendByLaplacianPyramid extends BasicSpecializingImageOpNode<typeof Definition, ImageOpBlendByLaplacianPyramidHal> {
    static nodeClass = "ImageOpNodeBlendByLaplacianPyramid"
    static definition = Definition

    constructor(parameters: ImageOpInputsOrNodes<typeof Definition>) {
        super(ImageOpBlendByLaplacianPyramidHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof Definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        return generateGraph(evaluatedParameters)
    }
}
